var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "48px",
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    width: "48px",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.054,9.945c0.55,0,1,0.45,1,1v28.67c0,0.55-0.45,1-1,1h-25.3   c-0.55,0-1-0.45-1-1V6.995c0-0.55,0.45-1,1-1h21.21c0.55,0,1,0.45,1,1v1.95c0,0.55,0.45,1,1,1H37.054z",
    style: {
      fill: "none",
      stroke: "#231F20",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("rect", {
    height: 6,
    style: {
      fill: "none",
      stroke: "#231F20",
      strokeMiterlimit: 10
    },
    width: 6,
    x: 14.154,
    y: 9.615
  }), /*#__PURE__*/React.createElement("rect", {
    height: 0.84,
    style: {
      fill: "#231F20"
    },
    width: 9.958,
    x: 22.123,
    y: 9.102
  }), /*#__PURE__*/React.createElement("rect", {
    height: 0.84,
    style: {
      fill: "#231F20"
    },
    width: 11.875,
    x: 22.133,
    y: 11.362
  }), /*#__PURE__*/React.createElement("rect", {
    height: 0.84,
    style: {
      fill: "#231F20"
    },
    width: 11.875,
    x: 22.133,
    y: 13.331
  }), /*#__PURE__*/React.createElement("rect", {
    height: 0.938,
    style: {
      fill: "#231F20"
    },
    width: 11.916,
    x: 22.217,
    y: 15.116
  }), /*#__PURE__*/React.createElement("rect", {
    height: 0.938,
    style: {
      fill: "#231F20"
    },
    width: 21.75,
    x: 13.633,
    y: 20.949
  }), /*#__PURE__*/React.createElement("rect", {
    height: 0.938,
    style: {
      fill: "#231F20"
    },
    width: 21.75,
    x: 13.717,
    y: 23.199
  }), /*#__PURE__*/React.createElement("rect", {
    height: 0.938,
    style: {
      fill: "#231F20"
    },
    width: 21.75,
    x: 13.717,
    y: 25.448
  }), /*#__PURE__*/React.createElement("rect", {
    height: 0.938,
    style: {
      fill: "#231F20"
    },
    width: 21.75,
    x: 13.801,
    y: 36.281
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.123,9.894c0.33,0.32,0.444,0.738,0.256,0.933l0,0c-0.188,0.194-0.609,0.092-0.939-0.228  l-3.925-3.807c-0.329-0.32-0.444-0.738-0.256-0.932l0,0c0.188-0.195,0.61-0.093,0.939,0.227L38.123,9.894z",
    style: {
      fill: "#231F20"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.a89169ef414ee8f5763b3997a159942e.svg";
export { ForwardRef as ReactComponent };